import { render, staticRenderFns } from "./HotelAgency.vue?vue&type=template&id=68aa8be4&"
import script from "./HotelAgency.vue?vue&type=script&lang=js&"
export * from "./HotelAgency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports